import React from 'react';
var ColorBlock = function (props) { return (React.createElement("div", { style: {
        backgroundColor: props.color,
        display: 'inline-block',
        width: '7rem',
        height: '7rem',
        margin: '0rem 1rem',
    } })); };
export default ColorBlock;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageKitchen/ColorBlock.tsx
// module id = 1326
// module chunks = 0